import { render, staticRenderFns } from "./PackageChanges.vue?vue&type=template&id=0f9d845c&scoped=true&"
import script from "./PackageChanges.vue?vue&type=script&lang=js&"
export * from "./PackageChanges.vue?vue&type=script&lang=js&"
import style0 from "./PackageChanges.vue?vue&type=style&index=0&id=0f9d845c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9d845c",
  null
  
)

export default component.exports